import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from '@mui/material';
export type ApprovalSlotState = 'approved' | 'pending' | 'denied';
export const ApprovalDots = t0 => {
  const $ = _c(5);
  const {
    slots
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "4px",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== slots) {
    t2 = slots.map(_temp);
    $[1] = slots;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Stack direction="row" sx={t1}>{t2}</Stack>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export const ApprovalDot = t0 => {
  const $ = _c(2);
  const {
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <Box sx={{
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: color
    }} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(state, i) {
  const color = state === "approved" ? "var(--mui-palette-success-main)" : state === "denied" ? "var(--mui-palette-error-main)" : "var(--mui-palette-divider)";
  return <ApprovalDot key={i} color={color} />;
}